import { Header } from '@business/workflows/ComponentUI/Header';
import { ProfileSidebar } from '@business/workflows/ComponentUI/ProfileSidebar/ProfileSidebar';
import { MediaUploadPersister } from '@business/workflows/ComponentViews/Photos';
import { FC, ReactNode } from 'react';

interface ProfileLayoutProps {
  children?: ReactNode;
  wrapperClassName?: string;
}

export const ProfileLayout: FC<ProfileLayoutProps> = ({
  children,
  wrapperClassName = 'max-w-7xl'
}) => {
  return (
    <div className="h-screen flex overflow-hidden bg-white relative">
      <ProfileSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <div className={`px-4 sm:px-5 lg:px-7 py-5 ${wrapperClassName}`}>
            {children}
          </div>
          <MediaUploadPersister />
        </main>
      </div>
    </div>
  );
};
